/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_mobile_analytics_app_id": "2e7b79896e4748af8e959c4d4e8797cf",
    "aws_mobile_analytics_app_region": "us-east-2",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "2e7b79896e4748af8e959c4d4e8797cf",
            "region": "us-east-2"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://dwdfqi55y5eihf7tq2mrg5vb6i.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-vfdtawk2tfamlc75fqk4r7w2vy",
    "aws_cloud_logic_custom": [
        {
            "name": "bazarhealthREST",
            "endpoint": "https://9w5f3npf2i.execute-api.us-east-2.amazonaws.com/stage",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:b48e180b-4880-4170-b7cf-76cd22117b7f",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_1cosNWqOo",
    "aws_user_pools_web_client_id": "4qomif2ouusipd0o01496oqmqm",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "bazarhealth-20221207143647-hostingbucket-stage",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d1wxfn6f50c8jn.cloudfront.net",
    "aws_user_files_s3_bucket": "bazarhealtha2da62319dd04201b98d37699a417a56132734-stage",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
